export default __webpack_public_path__ + "static/media/NFT7.271e0c71.png";